/**
 * Created by inonstelman on 12/28/14.
 */

(function () {
    'use strict';

    // @ngInject
    Services.Chart = function Chart($window) {
        if ($window.Chart) {
            return $window.Chart;
        }
        return {};
    };

}());
